
  import {
    Component,
    Model,
    Prop,
    Vue
  } from "vue-property-decorator";

  @Component({
    name: 'slz-switch',
  })
  export default class SlzSwitch extends Vue {
    @Prop({default: '开'}) private activeText!: string;
    @Prop({default: '关'}) private hideText!: string;
    @Model('change') isShow!: boolean;

    // 点击修改
    private handleClick() {
      // this.isShow = !this.isShow
      this.$emit('change', !this.isShow);
    }
  }
